import axios from "axios";

// In dev, "/" + the CRA "proxy" field in package.json forwards API calls to the
// Go backend on :3000's dev server — that proxy doesn't exist in a production
// build, so a deployed build needs REACT_APP_API_URL baked in at build time,
// pointing at wherever the backend is actually hosted (e.g. https://api.yourdomain.com).
const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // optional, for cookies or auth
});

// Several pages historically attached `Authorization: Bearer <token>` manually at
// each call site, and some (e.g. Payroll) never did — meaning every authed request
// from that page silently 401'd and fell back to fake local data. Attach it here
// once, globally, so no call site can forget it. An explicit header set by a caller
// still wins (axios merges config.headers over instance defaults).
axiosClient.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("accessToken");
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosClient;